import RequestPage from "./RequestPage";

const ExternalGlen = () => {
 return (
        <RequestPage title="External Retreat Glen"
            fetchUrl="/get-external-retreat-requests-gw"
            editEndpoint="edit-external-retreat-request-gw"
            deleteEndpoint="external-retreat-request-gw"
            statusEndpoint="external-retreat-request-gw" />
    );
}

export default ExternalGlen;